import { Paper, Stack, Text } from '@mantine/core';
import { Link } from '@tanstack/react-router';

import { TitleCard } from '@/core/components';

import { Course } from './../../model/CourseTypes';
import classes from './CourseCard.module.css';

export interface CourseCardProps {
  course: Course;
  to?: string;
  onClick?: () => void;
}

export function CourseCard({ course, to, onClick }: CourseCardProps) {
  const { title, publisher, noOfPages, year } = course;

  return (
    <Paper
      className={classes.card}
      component={to ? Link : undefined}
      to={to}
      onClick={onClick}
      p="lg"
      c="var(--mantine-color-text)"
    >
      <Stack gap="4px">
        <TitleCard title={`${title} (${year})`} />
        <Text size="sm">Publicat la: {publisher?.title ?? '-'}</Text>
        <Text
          c="dimmed"
          size="xs"
        >
          {noOfPages} pagini
        </Text>
      </Stack>
    </Paper>
  );
}
